module.exports = __webpack_public_path__ + "static/media/iconfinder_devices_headphone_1287555.c0cbd244.svg";